export default {"src":"/_next/static/media/avatarPlus5_40.48f3d54a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};